import {
    KEY_ISSUE_LIST_SEARCH_REQUEST,
    KEY_ISSUE_LIST_PAGE_REQUEST,
    KEY_ISSUE_LIST_RESPONSE,
    KEY_ISSUE_ITEM_REQUEST,
    KEY_ISSUE_ITEM_RESPONSE,
    KEY_ISSUE_SET_FILTER,
    KEY_ISSUE_SET_EDIT_MODE,
    KEY_ISSUE_UPDATE_FILTER_CRITERIA,
    KEY_ISSUE_CLEAR_FILTER_CRITERIA,
    KEY_ISSUE_APPLY_FILTER_CRITERIA,
    KEY_ISSUE_UPDATE_IMAGE,
    KEY_ISSUE_UPDATE_MODEL,
    KEY_ISSUE_APPLY_MODEL_UPDATE,
    KEY_ISSUE_CANCEL_MODEL_UPDATE,
    KEY_ISSUE_ADD_NEW,
    KEY_ISSUE_ADD_PLACEHOLDER_IMAGES,
    KEY_ISSUE_UPDATE_PLACEHOLDER_ATTRIBUTION,
    KEY_ISSUE_REMOVE_PLACEHOLDER,
    KEY_ISSUE_UPDATE_CONCEPTS,
    KEY_ISSUE_CLEAR_CONCEPTS,
    KEY_ISSUE_ADD_MAPPING,
    KEY_ISSUE_REMOVE_MAPPING,
    KEY_ISSUE_MAPPING_PREVIEW_REQUEST,
    KEY_ISSUE_MAPPING_DELETE_PREVIEW_REQUEST,
    KEY_ISSUE_MAPPING_PREVIEW_RESPONSE,
    KEY_ISSUE_MAPPING_PREVIEW_ERROR_RESPONSE,
    KEY_ISSUE_SELECT_PERMISSION_HOLDER_TYPE,
    KEY_ISSUE_REMOVE_OWNER_VIEWER,
    KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS,
    KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE,
    KEY_ISSUE_SELECT_ADD_OWNER_VIEWER,
    KEY_ISSUE_APPLY_ADD_OWNERS_VIEWERS,
    KEY_ISSUE_CANCEL_ADD_OWNERS_VIEWERS,
    KEY_ISSUE_ITEM_SAVE_RESPONSE
} from "./action-types"

import {
    itemRequest,
    itemResponse,
    listPageRequest,
    listSearchRequest,
    listResponse,
    setFilter,
    setEditMode,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateImage,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    defaultAction
} from "./default-actions/presentation-actions"
import {
    addPlaceholderImages,
    updatePlaceholder
} from "./default-actions/placeholder-actions"
import {
    updateConcepts,
    removeMapping,
    mappingPreviewRequest,
    mappingPreviewResponse,
    mappingPreviewErrorResponse
} from "./default-actions/mapping-actions"
import {
    selectPermissionHolderType,
    removeOwnerViewer,
    searchAddOwnersViewers,
    searchAddOwnersViewersResponse,
    selectAddOwnerViewer
} from "./default-actions/owner-viewer-actions"

export const keyIssueItemRequest = itemRequest(KEY_ISSUE_ITEM_REQUEST)
export const keyIssueItemResponse = itemResponse(KEY_ISSUE_ITEM_RESPONSE)
export const keyIssueItemSaveResponse = itemResponse(KEY_ISSUE_ITEM_SAVE_RESPONSE)
const keyIssueListResponse = listResponse(KEY_ISSUE_LIST_RESPONSE)
export const keyIssueListPageRequest = listPageRequest(
    KEY_ISSUE_LIST_PAGE_REQUEST,
    keyIssueListResponse
)
export const keyIssueListSearchRequest = listSearchRequest(
    KEY_ISSUE_LIST_SEARCH_REQUEST,
    keyIssueListResponse
)
export const keyIssueSetFilter = setFilter(KEY_ISSUE_SET_FILTER)
export const keyIssueSetEditMode = setEditMode(KEY_ISSUE_SET_EDIT_MODE)
export const keyIssueUpdateFilterCriteria = updateFilterCriteria(
    KEY_ISSUE_UPDATE_FILTER_CRITERIA
)
export const keyIssueClearFilterCriteria = clearFilterCriteria(
    KEY_ISSUE_CLEAR_FILTER_CRITERIA
)
export const keyIssueApplyFilterCriteria = applyFilterCriteria(
    KEY_ISSUE_APPLY_FILTER_CRITERIA
)
export const keyIssueUpdateModel = updateModel(KEY_ISSUE_UPDATE_MODEL)
export const keyIssueUpdateImage = updateImage(KEY_ISSUE_UPDATE_IMAGE)
export const keyIssueApplyModelUpdate = applyModelUpdate(
    KEY_ISSUE_APPLY_MODEL_UPDATE
)
export const keyIssueCancelModelUpdate = cancelModelUpdate(
    KEY_ISSUE_CANCEL_MODEL_UPDATE
)
export const keyIssueAddNew = defaultAction(KEY_ISSUE_ADD_NEW)

export const keyIssueListInvalidationRequest = pagingRequest =>
    keyIssueListPageRequest({
        ...pagingRequest,
        isInvalidating: true,
        offset: 0,
        nextOffset: 0
    })

// Placeholder actions
export const keyIssueAddPlaceholderImages = addPlaceholderImages(
    KEY_ISSUE_ADD_PLACEHOLDER_IMAGES
)
export const keyIssueUpdatePlaceholderAttribution = updatePlaceholder(
    KEY_ISSUE_UPDATE_PLACEHOLDER_ATTRIBUTION
)
export const keyIssueRemovePlaceholder = updatePlaceholder(
    KEY_ISSUE_REMOVE_PLACEHOLDER
)

// Mapping actions
export const keyIssueUpdateConcepts = updateConcepts(KEY_ISSUE_UPDATE_CONCEPTS)
export const keyIssueClearConcepts = defaultAction(KEY_ISSUE_CLEAR_CONCEPTS)
export const keyIssueAddMapping = defaultAction(KEY_ISSUE_ADD_MAPPING)
export const keyIssueRemoveMapping = removeMapping(KEY_ISSUE_REMOVE_MAPPING)
export const keyIssueMappingPreviewRequest = mappingPreviewRequest(
    KEY_ISSUE_MAPPING_PREVIEW_REQUEST
)
export const keyIssueMappingDeletePreviewRequest = mappingPreviewRequest(
    KEY_ISSUE_MAPPING_DELETE_PREVIEW_REQUEST
)
export const keyIssueMappingPreviewResponse = mappingPreviewResponse(
    KEY_ISSUE_MAPPING_PREVIEW_RESPONSE
)
export const keyIssueMappingPreviewErrorResponse = mappingPreviewErrorResponse(
    KEY_ISSUE_MAPPING_PREVIEW_ERROR_RESPONSE
)

// Owner/Viewer actions
export const keyIssueSelectPermissionHolderType = selectPermissionHolderType(
    KEY_ISSUE_SELECT_PERMISSION_HOLDER_TYPE
)
export const keyIssueRemoveOwnerViewer = removeOwnerViewer(
    KEY_ISSUE_REMOVE_OWNER_VIEWER
)
export const keyIssueSearchAddOwnersViewers = searchAddOwnersViewers(
    KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS
)
export const keyIssueSearchAddOwnersViewersResponse = searchAddOwnersViewersResponse(
    KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE
)
export const keyIssueSelectAddOwnerViewer = selectAddOwnerViewer(
    KEY_ISSUE_SELECT_ADD_OWNER_VIEWER
)
export const keyIssueApplyAddOwnersViewers = defaultAction(
    KEY_ISSUE_APPLY_ADD_OWNERS_VIEWERS
)
export const keyIssueCancelAddOwnersViewers = defaultAction(
    KEY_ISSUE_CANCEL_ADD_OWNERS_VIEWERS
)
